import { render, staticRenderFns } from "./RibForm.vue?vue&type=template&id=da8c9e14&"
import script from "./RibForm.vue?vue&type=script&lang=js&"
export * from "./RibForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports